<template>
  <div>
    <zx-table
      :tableData="tableData"
      :option="table"
      :page="page"
      :searchDesc="searchDesc"
      @searchSubmit="searchSubmit"
      @handleSelectionChange="handleSelectionChange"
      @delBtn="delBtn"
      @refresh-change="getlist"
      @addSubmit="addSubmit"
      @etidSubmit="etidSubmit"
      @refreshBtn="refreshBtn"
    ></zx-table>
  </div>
</template>

<script>
import * as account from "@/api/account/account.js";
import * as dept from "@/api/dept/dept.js";
import * as post from "@/api/post/post.js";
import xzTable from "@/components/xz-table.vue";
export default {
  name: "account-list",
  components: {
    "zx-table": xzTable
  },
  data() {
    return {
      searchDesc: {
        nickname: {
          field: "nickname",
          label: "名称",
          type: "input"
        },
        mobile: {
          field: "mobile",
          label: "手机号",
          type: "input"
        },
        role_id: {
          field: "role_id",
          label: "角色",
          type: "select",
          options: account.getRoleList.r(),
          prop: {
            text: "role_name",
            value: "role_id"
          }
        }
      },
      page: {
        total: 1,
        pagerCount: 1,
        currentPage: 1,
        pageSize: 10,
        pageSizes: [1, 3, 10, 20, 30, 40, 50, 100],
        layout: "total, sizes, prev, pager, next, jumper",
        background: true
      },
      table: {
        title: "员工",
        // 表格底部按钮
        btnBottom: false,
        // 操作按钮列定位 默认:false;
        fixed: false,
        // 子表格 默认: ; 数据格式:String;<对应子行字段名称>
        children: "children",
        // 多选 默认:false;
        selection: false,
        // 单选高亮
        current: true,
        //搜索框 默认:false;
        searchBtn: true,
        // 表格高度 默认:100%; 数据格式:Number;
        // height:500,
        // 数边框 默认:false;
        border: false,
        //索引 默认:true;
        index: true,
        // 刷新 默认:true;
        refreshBtn: true,
        // 添加 默认:true;
        addBtn: true,
        // 编辑 默认:true;
        editBtn: true,
        // 导出 默认false
        exportBtn: true,
        // 删除  默认:true;
        delBtn: true,
        // 折叠筐 默认:false;
        expand: false,
        column: [
          {
            // 字段
            prop: "user_name",
            // 列名
            label: "名称",
            // 表单 类型
            type: "input",
            // 是否必须输入
            required: true,
            layout: 12,
            // 表格是否显示
            hide: true,
            // 该字段是否可以在创建时编辑 默认:true;
            addDisplay: true,
            // 该字段是否可以修改默认true
            editDisplay: true,
            // 倒叙 默认:false;
            // 该字段是否可以在筛选 默认:false;
            // searchDisplay: true,
            sortable: false
          },
          {
            layout: 12,
            prop: "phone_number",
            label: "手机号",
            type: "input",
            hide: true,
            required: true,
            // 该字段是否可以在创建时编辑 默认:true;
            addDisplay: true,
            // 该字段是否可以修改默认true
            editDisplay: true,
            // 倒叙 默认:false;
            // 该字段是否可以在筛选 默认:false;
            searchDisplay: true
          },
          {
            layout: 12,
            prop: "login_name",
            label: "用户名",
            type: "input",
            hide: true,
            required: true
          },
          {
            layout: 12,
            prop: "password",
            hide: false,
            label: "密码",
            type: "password",
            required: true,
            // 该字段是否可以修改默认true
            editDisplay: false,
            rules: {
              // validator: validatePass,
              min: 8,
              message: "密码最少8个字符",
              trigger: "blur"
            }
          },
          {
            layout: 12,
            prop: "email",
            label: "邮箱",
            type: "input",
            hide: true,
            required: true,
            // 该字段是否可以在创建时编辑 默认:true;
            addDisplay: true,
            // 该字段是否可以修改默认true
            editDisplay: true
            // 倒叙 默认:false;
          },
          {
            prop: "dept_id",
            label: "部门",
            type: "cascader",
            hide: false,
            required: true,
            show: "tag",
            attrs: {
              props: {
                value: "id"
              },
              showAllLevels: false,
              showCheckbox: false,
              defaultExpandAll: true
            },
            layout: 12
          },
          {
            prop: "role_ids",
            label: "角色",
            attrs: {
              multiple: true
            },
            type: "select",
            hide: false,
            required: true,
            show: "tag"
          },

          {
            prop: "post_ids",
            label: "岗位",
            type: "select",
            hide: false,
            required: true,
            show: "tag",
            layout: 24,
            attrs: {
              multiple: true
            }
          },
          {
            layout: 12,
            prop: "status",
            label: "状态",
            type: "select",
            show: "tag",
            hide: true,
            width: 100,
            required: true,
            default: 0,
            options: [
              {
                text: "正常",
                value: 0
              },
              {
                text: "禁用",
                value: 1
              }
              // {
              // 	text: "删除",
              // 	value: -1
              // }
            ],
            tagtype: [
              {
                text: "正常",
                type: "success",
                value: 0
              },
              {
                text: "禁用",
                type: "danger",
                value: 1
              }
              // {
              // 	text: "删除",
              // 	type: "info",
              // 	value: -1
              // }
            ]
          },
          {
            layout: 12,
            prop: "sex",
            label: "性别",
            type: "select",
            show: "tag",
            hide: true,
            width: 100,
            required: true,
            default: 2,
            options: [
              {
                text: "男",
                value: 0
              },
              {
                text: "女",
                value: 1
              },
              {
                text: "保密",
                value: 2
              }
            ],
            tagtype: [
              {
                text: "男",
                value: 0
              },
              {
                text: "女",
                value: 1
              },
              {
                text: "保密",
                value: 2
              }
            ]
          },
          {
            prop: "create_time",
            label: "创建时间",
            hide: false,
            // 该字段是否可以在创建时编辑 默认:true;
            addDisplay: false,
            // 该字段是否可以修改默认true
            editDisplay: false
          }
        ]
      },
      tableData: [],
      roleList: [],
      apiUrl: "v1/user/index"
    };
  },
  created() {
    this.getRoleDataList();
    this.getlist();
    // this.formDesc.this.username.options =
  },
  mounted() {
    this.getRoleDataList();
  },
  methods: {
    getRoleDataList() {
      account.getRoleList.r().then(res => {
        let data = res;
        let array = [];
        for (let i = 0; i < data.length; i++) {
          array.push({
            text: data[i].role_name,
            value: data[i].role_id
          });
        }
        this.searchDesc.role_id["options"] = array;
        this.table.column[6]["options"] = array;
        this.table.column[6]["tagtype"] = array;
      });
      dept.getDeptTree.r().then(res => {
        this.table.column[5]["options"] = res;
      });
      post.getPostAll.r().then(res => {
        let data = res;
        let array = [];
        for (let i = 0; i < data.length; i++) {
          array.push({
            text: data[i].post_name,
            value: data[i].post_id
          });
        }
        this.table.column[7]["options"] = array;
      });
    },
    getlist(e) {
      let that = this;
      let param;
      if (e) {
        that.page = e;
        param = {
          page: e.currentPage,
          limit: e.pageSize
        };
      } else {
        param = {
          page: this.page.currentPage,
          limit: this.page.pageSize
        };
      }
      if (this.searchData) {
        param = {
          page: this.page.currentPage,
          limit: this.page.pageSize,
          ...this.searchData
        };
      }
      account.getAccount.r(param).then(res => {
        that.tableData = res.list;
        that.page.total = res.total;
      });
    },
    // 筛选条件
    searchSubmit(e) {
      this.searchData = e;
      this.getlist();
    },
    // 多选
    handleSelectionChange(e) {},
    // 添加提交
    addSubmit(form) {
      // dept_id
      form.dept_id = form.dept_id[form.dept_id.length - 1];
      // form[] = []
      account.addAccount.r(form).then(res => {
        this.$message.success("账号" + res.user_name + "创建成功");
        this.getlist();
      });
    },
    // 编辑
    etidSubmit(form) {
      form.dept_id = form.dept_id[form.dept_id.length - 1];
      account.upDataAccount.r(form).then(res => {
        this.$message.success("修改成功");
        this.getlist();
      });
    },
    // 删除
    delBtn(form) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          account.deleteAccount.r({ user_id: form.user_id }).then(res => {
            this.$message.success("《" + form.user_name + "》删除成功");
            this.getlist();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 刷新
    refreshBtn(e) {
      this.getlist();
    }
  }
};
</script>

<style lang="scss" scoped>
.xvue-crud {
  th {
    word-break: break-word;
    color: rgba(0, 0, 0, 0.85);
    background-color: #fafafa;
  }
}
</style>
